import { FormControl, FormGroup } from "@mui/material";
import { ReactNode } from "react";

interface CheckboxGroupProps {
    children: ReactNode;
    ariaLabel?: string;
}

export const CheckboxGroup = ({ children, ariaLabel }: CheckboxGroupProps) => (
    <FormControl component={"fieldset"} aria-label={ariaLabel}>
        <FormGroup>{children}</FormGroup>
    </FormControl>
);
